import React from 'react';
import { Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

const badgeStyles = {
  hire: {
    bg: '#ECFDF5',
    color: '#065F46',
    label: 'Hire',
  },
  departure: {
    bg: '#FEF2F2',
    color: '#991B1B',
    label: 'Departure',
  },
};

const defaultBadgeStyle = {
  bg: '#F3F4F6',
  color: '#374151',
};

export const MovementTypeBadge = ({ data }) => {
  const { colors } = useTheme();
  const movement = data?.original;

  if (movement?.isSkeleton) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={48}
        viewBox="0 0 400 48"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="8" y="14" rx="10" ry="10" width="70" height="20" />
      </ContentLoader>
    );
  }

  const movementType = movement?.movementType || '';
  const style = badgeStyles[movementType] || defaultBadgeStyle;
  const label = badgeStyles[movementType]?.label || movementType.charAt(0).toUpperCase() + movementType.slice(1);

  if (!movementType) {
    return (
      <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
        <Text fontSize="14px" color="text.subtle">
          -
        </Text>
      </Flex>
    );
  }

  return (
    <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
      <Text
        fontSize="12px"
        fontWeight="600"
        sx={{
          bg: style.bg,
          color: style.color,
          px: '10px',
          py: '4px',
          borderRadius: '6px',
          whiteSpace: 'nowrap',
          lineHeight: '16px',
          letterSpacing: '0.01em',
        }}
      >
        {label}
      </Text>
    </Flex>
  );
};

MovementTypeBadge.propTypes = {
  data: PropTypes.object,
};

MovementTypeBadge.defaultProps = {
  data: {},
};
